import { SERVER_URL } from '../../../constants';
import {
  fetchGetAuth,
  fetchPostAuth,
} from '../../../util/FetchUtil';

const controller = 'cantina-credito-solicitacao/';

export const criarCantinaCreditoSolicitacaoTransacaoPix = (cantinaCreditoSolicitacao) => {
  const url = SERVER_URL + controller + "criar-transacao-via-pix";
  return fetchPostAuth(url, cantinaCreditoSolicitacao);
}

export const criarCantinaCreditoSolicitacaoTransacaoCartaoCredito = (cantinaCreditoSolicitacao) => {
  const url = SERVER_URL + controller + "criar-transacao-via-cartao-credito";
  return fetchPostAuth(url, cantinaCreditoSolicitacao);
}

export const consultaCantinaCreditoSolicitacaoTransacaoPix = (codCantinaCreditoSolicitacao) => {
  const url = SERVER_URL + controller + "consulta-transacao/" + codCantinaCreditoSolicitacao;
  return fetchGetAuth(url);
}

export const findCantinaCreditoSolicitacaoByCurrentInstituicao = (page) => {
  const url = SERVER_URL + controller + "page-query?page=" + page;
  return fetchGetAuth(url);
}